export enum SOURCE_IMG_TYPE {
    CUSTOM, // 图片链接
    AVATAR, // 头像
    SESSION, //小节图标
    IMG_DATA, // 图片数据
}

export interface IRecommendImgInfo {
    id: string;
    url: string;
    thumb?: string;
}

export interface RenderUploadImageAndCropDialogProps {
    title?: string;
    userId: string;
    urls: string;
    cropRatio: number;
    multiple?: number;
    closable?: boolean;
    sourceImgType: number;
    isShowToolBar?: boolean;
    isShowDefaultImg?: boolean;
    defaultImgList?: IRecommendImgInfo[];
    bannerList?: IRecommendImgInfo[];
    illustrationList?: IRecommendImgInfo[];
    onConfirm: (url: string) => void;
    onClose?: () => void;
    zIndex?: number;
}

export interface ImgSourceProps {
    imgSrc: string;
    userId: string;
    multiple?: number;
    isShowToolBar?: boolean;
    uploadLoadText?: string;
    isShowDefaultImg?: boolean;
    sourceImgType?: SOURCE_IMG_TYPE;
    defaultImgList?: IRecommendImgInfo[];
    panelTitle?: string;
    cropRatio: number;
    bannerList?: IRecommendImgInfo[];
    illustrationList?: IRecommendImgInfo[];
    onConfirm: (url: string) => void;
    onClose: () => void;
}

export interface IImgCardProps {
    list: IRecommendImgInfo[];
    selectData: IRecommendImgInfo;
    type: string; // 作为ID前缀，避免数据前缀重复
    label: string | JSX.Element;
    className?: string;
    onChange: (data: IRecommendImgInfo) => void;
}

export enum IMG_UPLOAD_TYPE {
    UPLOAD_SELF = 'uploadSelf',
    RECOMMEND_BY_UMU = 'recommendByUmu',
}

export interface IUploadFileProps {
    accept?: string;
    children: string | JSX.Element;
    onChooseFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
    multiple?: boolean;
}

export type UploadImageAndCropProps = {
    title?: string;
    userId: string;
    accept?: string;
    cropRatio?: number;
    closable?: boolean;
    sourceImgType?: number;
    children: string | JSX.Element;
    onUploadCallback?: (url: string) => void;
};
